import { render, staticRenderFns } from "./ResourceEditor.vue?vue&type=template&id=27c1ad48&scoped=true&"
import script from "./ResourceEditor.vue?vue&type=script&lang=js&"
export * from "./ResourceEditor.vue?vue&type=script&lang=js&"
import style0 from "./ResourceEditor.vue?vue&type=style&index=0&id=27c1ad48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c1ad48",
  null
  
)

export default component.exports